import ShiftLogBook from '../../../modules/superAdmin/dashboard';
import ShiftInfoPage from '../../../modules/superAdmin/dashboard/ShiftInfo';
import HotWorkApproval from '../../../modules/superAdmin/HotWorkApproval';
import HVworkPermits from '../../../modules/superAdmin/HVworkPermits';
import HVworkPermitDetails from '../../../modules/superAdmin/HVworkPermits/HVworkPermitDetails';
import OperatingInstruction from '../../../modules/superAdmin/OperatingInstruction';
import InfoInstruction from '../../../modules/superAdmin/OperatingInstruction/InfoInstruction';
import OutageRequisition from '../../../modules/superAdmin/OutageRequisition';
import OutageReqDetail from '../../../modules/superAdmin/OutageRequisition/OutrageRequisitionDetail';
import PlantSafetyRegulation from '../../../modules/superAdmin/PlantSafetyRegulation';
import Reports from '../../../modules/superAdmin/Reports';
import Settings from '../../../modules/superAdmin/Settings';
import SpecificInstruction from '../../../modules/superAdmin/SpecificInstruction';
import SpecificInstructionDetails from '../../../modules/superAdmin/SpecificInstruction/SpecificInstructionDetail';
import TemporaryOperatingInstruction from '../../../modules/superAdmin/TemporaryOperatingInstruction';
import TempOperatingInstructionDetails from '../../../modules/superAdmin/TemporaryOperatingInstruction/TempOperatingInstructionDetails';
import Users from '../../../modules/superAdmin/Users';
import UserDetails from '../../../modules/superAdmin/Users/UserDetails';
import HotWorkApprovalDetail from '../../../modules/superAdmin/HotWorkApproval/HotWorkApprovalDetail';
import PlantSafetyWorkPermitDetail from '../../../modules/superAdmin/PlantSafetyRegulation/PlantSafetyWorkPermitDetail';
import LeaveRoaster from '../../../modules/superAdmin/LeveRoaster/index';
import LeaveRosterDetails from '../../../modules/superAdmin/LeveRoaster/LeaveRosterDetails';
import ShiftRoster from '../../../modules/superAdmin/ShiftRoaster';
import ShiftCalendar from '../../../modules/superAdmin/ShiftRoaster/ShiftCalender';
import GroupManagement from '../../../modules/superAdmin/ShiftRoaster/GroupManagement';
import DutyCodeTab from '../../../modules/superAdmin/ShiftRoaster/DutyCardTab';
import NotificationList from '../../../modules/superAdmin/Settings/NotificationList';
import UserInfo from '../../../modules/superAdmin/Settings/UserInfo';
import PasswordSecurity from '../../../modules/superAdmin/Settings/PasswordSecurity';
import PrivacyPolicy from '../../../modules/superAdmin/Settings/PrivacyPolicy';
import Departments from '../../../modules/superAdmin/Settings/Departments';
import MasterSection from '../../../modules/superAdmin/Master/MasterSection';
import Sites from '../../../modules/superAdmin/Master/Sites';
import PlantCodes from '../../../modules/superAdmin/Master/PlantCodes';
import PlantRequiringIsolations from '../../../modules/superAdmin/Master/PlantRequiringIsolations';

const routes = [
  {
    path: '/ShiftLogbook',
    element: <ShiftLogBook />,
  },
  {
    path: '/ShiftLogbook/:id',
    element: <ShiftInfoPage />,
  },
  {
    path: '/OperatingInstruction',
    element: <OperatingInstruction />,
  },
  {
    path: '/OperatingInstruction/:id',
    element: <InfoInstruction />,
  },
  {
    path: '/TemporaryOperatingInstruction',
    element: <TemporaryOperatingInstruction />,
  },
  {
    path: '/TemporaryOperatingInstruction/:id',
    element: <TempOperatingInstructionDetails />,
  },
  {
    path: '/OutageRequisition',
    element: <OutageRequisition />,
  },
  {
    path: '/OutageRequisition/:id',
    element: <OutageReqDetail />,
  },
  {
    path: '/SpecificInstruction',
    element: <SpecificInstruction />,
  },
  {
    path: '/SpecificInstruction/:id',
    element: <SpecificInstructionDetails />,
  },
  {
    path: '/Report',
    element: <Reports />,
  },
  {
    path: '/settings',
    element: <Settings />,
    children: [
      //{ index: true, element: <UserInfo /> },
      { path: 'user-info', element: <UserInfo /> },
      { path: 'password', element: <PasswordSecurity /> },
      { path: 'notifications', element: <NotificationList /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
    ],
  },
  {
    path: '/master',
    element: <MasterSection />,
    children: [
      { index: true, element: <Departments /> },
      { path: 'departments', element: <Departments /> },
      { path: 'sites', element: <Sites /> },
      { path: 'plant-codes', element: <PlantCodes /> },
      { path: 'plant-requiring-isolations', element: <PlantRequiringIsolations /> },
    ],
  },
  {
    path: '/Users',
    element: <Users />,
  },
  {
    path: '/Users/:id',
    element: <UserDetails />,
  },
  {
    path: '/HVworkPermits',
    element: <HVworkPermits />,
  },
  {
    path: '/HVworkPermits/:id',
    element: <HVworkPermitDetails />,
  },
  {
    path: '/PlantSafetyRegulation',
    element: <PlantSafetyRegulation />,
  },
  {
    path: '/PlantSafetyRegulation/:id',
    element: <PlantSafetyWorkPermitDetail />,
  },
  {
    path: '/HotWorkApproval',
    element: <HotWorkApproval />,
  },
  {
    path: '/HotWorkApproval/:id',
    element: <HotWorkApprovalDetail />,
  },
  {
    path: '/LeaveRoster',
    element: <LeaveRoaster />,
  },
  {
    path: '/LeaveRoster/:id',
    element: <LeaveRosterDetails />,
  },
  {
    path: '/ShiftRoster',
    element: <ShiftRoster />,
  },
  {
    path: '/ShiftRoster/configuration',
    element: <GroupManagement />,
  },
  {
    path: '/ShiftRoster/configuration/dutycode',
    element: <DutyCodeTab />,
  },
  {
    path: '/ShiftRoster/:id',
    element: <ShiftCalendar />,
  },
  {
    path: '/notifications',
    element: <NotificationList />,
  },
];
export default routes;
